import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReserveTableService {
  private baseUrl = `${environment.apiUrl}/api/udaan`;

  constructor(private http: HttpClient) {}

  getDiningSettings(restaurantId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/dinings/settings/${restaurantId}`);
  }

  getAvailableSlots(restaurantId: string, date: string, start: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/${restaurantId}/sections/available-slots?date=${date}&start=${encodeURIComponent(start)}`
    );
  }

   makeReservation(restaurantId: string, data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/restaurants/${restaurantId}/reservation`,
      data
    );
  }
}